// extracted by mini-css-extract-plugin
export default {"title":"Daa-z","warning":"Eaa-z","sizeOptionsLegendText":"Faa-z"};